import { graphql } from "@/lib/gql/__generated__";

export const HpbPageList_HpbPageListPage_Query = graphql(`
	query HpbPageList_HpbPageListPage($hotelID: ID!) {
		hpbPageList(hotelID: $hotelID) {
			id
			pages {
				id
				uuid
				hotelID
				slug
				title
				description
				thumbnail
				studio {
					bucket
					key
					region
					mimeType
					fileName
				}
				staticPageType
				createdAt
				updatedAt
			}
		}
	}
`);
